import { memo } from "react";
import { ButtonViewTaskLogsProps } from "components/ButtonViewTaskLogs/ButtonViewTaskLogs";
import { ButtonIconPlain } from "../plain/ButtonIconPlain";
import { DATA_TABLE_TOOLTIP_ID } from "../layout/DataTableTooltip";
import { TaskStatus } from "types/constants";
import { useModalContext } from "providers/ModalProvider/ModalProvider";
import { ModalTaskLogs } from "components/ButtonViewTaskLogs/ModalTaskLogs";

/**
 * Cell renderer a button to view the logs of a completed task
 */
const CellRendererTaskLogs = (props: ButtonViewTaskLogsProps) => {
  const { openModal, closeModal } = useModalContext();

  if (props.taskStatus === TaskStatus["CANCELED"]) {
    return null; // Do not render logs if task is canceled
  }

  const buttonDisabled =
    props.taskStatus !== TaskStatus["COMPLETE"] &&
    props.taskStatus !== TaskStatus["ERROR"] &&
    props.taskStatus !== TaskStatus["FAILED"];

  const showModal = () =>
    openModal(
      <ModalTaskLogs
        task={{
          id: props.taskId,
          status: props.taskStatus,
          created: props.taskCreated,
        }}
        onClose={closeModal}
      />,
    );

  return (
    <ButtonIconPlain
      {...props}
      aria-label="View task logs"
      disabled={buttonDisabled}
      color="primary"
      iconSize="m"
      iconType="tableDensityExpanded"
      onClick={showModal}
      data-tooltip-id={DATA_TABLE_TOOLTIP_ID}
      data-tooltip-content={
        buttonDisabled ? "Task log available upon completion" : "View task logs"
      }
    />
  );
};

export const CellRendererTaskLogsMemo = memo(CellRendererTaskLogs);
